import React, { Children, forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import * as rsuite from 'rsuite';
// import Cascader from 'rsuite/Cascader';

// (Optional) Import component styles. If you are using Less, import the `index.less` file. 
import 'rsuite/Cascader/styles/index.css';


const Drp_PickerCity = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(0);
    const [DefultId, setDefultId] = React.useState(0);
    const Group_Onchange = (Id) => {
        if (Id * 1 < 0) {
            props.onChange(DefultId, List.find(x => x.Id == DefultId).Title)
            setId(DefultId)
        }
        else {
            props.onChange(Id == null || Id < 1 ? -1 : Id, Id == null || Id*1 < 1 ? "" : List.find(x => x.Id == Id).Title)
            setId(Id)

        }
    }
    useImperativeHandle(ref, () => ({
        Bind(id, title) {

            var RequestOptions = {
                data: {
                    'Title': title
                },
                url: General.ApiRoute() + "/ProvinceCity/Search",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var tmp = []
                        var selectid = 0;
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                // value: result.data[i].value,
                                // label: result.data[i].label,
                                // children: result.data[i].children,
                                Title: result.data[i].provinceTitle + " - " + result.data[i].title,
                                Id: result.data[i].id
                            })

                            if (result.data[i].isDefualt == 1) {
                                selectid = result.data[i].id;
                                setDefultId(result.data[i].id)
                                props.onChange(result.data[i].id, result.data[i].provinceTitle + " - " + result.data[i].title)
                            }
                            else if (id != 0 && id == result.data[i].id) {
                                selectid = id;
                                props.onChange(id, result.data[i].provinceTitle + " - " + result.data[i].title)
                            }

                        }
                        setList(tmp)
                        setId(selectid)

                        // setTimeout(() => {
                        // }, 200)
                    }).catch((error) => {
                        // toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        },
        Select(id) {
            Group_Onchange(id)
        }

    }))


    return (

        <rsuite.SelectPicker
            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب استان / شهر..."
            value={Id}
            // defaultValue={Id}
            onChange={(value) => Group_Onchange(value)}

        />


    )
});

export default Drp_PickerCity;